import { render, staticRenderFns } from "./Generico-G900.vue?vue&type=template&id=14740d6c"
import script from "./Generico-G900.vue?vue&type=script&lang=js"
export * from "./Generico-G900.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports